export default {
  finance: {
    salesInvoices: 'Faktury sprzedaży',
    FVS: 'FVS',
    lastModification: 'Ostatnia modyfikacja do zatwierdzenia',
    verification: 'Weryfikacja',
    amountToCorrect: 'Kwota do korekty',
    amountToInvoice: 'Kwota do zafakturowania',
    forContractor: 'w ramach klienta',
    andBudget: 'i budżetu',
    toInvoice: 'do faktury',
    askCreateInvoiceDraft:
      'Uwaga: zostanie automatycznie utworzony szkic korekty do faktury sprzedaży nr {{number}}. Czy na pewno chcesz kontynuować?',
    issuingCorrection: 'Wystaw korektę',
    saveAndStepForward: 'Zapisz i przejdź dalej',
    paymentForm: 'Forma płatności',
    paymentDate: 'Termin płatności',
    paymentDateFromReceive: 'Data płatności od dnia otrzymania',
    paymentReceivedDate: 'Data wpłaty',
    invoiceNumber: 'Numer faktury',
    correctedInvoiceNumber: 'Numer faktury korygującej',
    nip: 'NIP',
    askDeleteInvoiceDraft:
      'Czy na pewno chcesz usunąć wyświetlany szkic faktury?',
    documentCodes: 'Kody dokumentu',
    gtuCode: 'Kod GTU',
    financialAccount: 'Konto księgowe',
    was: 'było',
    is: 'jest',
    commission: 'Prowizja',
    commissionFinancialAccount: 'Konto księgowe prowizji',
    sumToInvoiceSaleAndCommission: 'Suma do fakturowania sprzedaży i prowizji',
    mergedPositionsSameAccount:
      'Scalane pozycje muszą być przypisane do tego samego konta księgowego oraz należeć do',
    mergePositions: 'Scal pozycje',
    askMergePositions: 'Czy na pewno chcesz scalić pozycje?',

    askResetPositions: 'Czy na pewno chcesz zresetować pozycje?',
    clonePosition: 'Klonuj pozycję',
    clonePositionOnce: 'Klonuj raz',
    clonePositionMultiple: 'Klonuj wielokrotnie',
    clonePositionCount: 'Liczba kopii, które mają powstać',
    resetPositions: 'Resetuj wszystkie pozycje',
    mergePositionsBy: 'Scal pozycje według',
    mergeSelectedPositionsBy: 'Scal wybrane pozycje według',
    netAmount: 'Kwota netto',
    vat: 'Stawka VAT',
    netAmountInCurrency: 'Kwota netto w walucie',
    grossAmount: 'Kwota brutto',
    sumToInvoice: 'Suma do fakturowania',
    correctionAmount: 'Kwota korekty',
    print: 'Wydruk',
    fvsData: 'Dane do FVS',
    duplicate: 'Duplikat',
    copy: 'Kopia',
    addedWithinBudget: 'dodanych w ramach budżetu',
    noInvoices: 'Brak faktur sprzedaży w systemie.',
    buyerName: 'Nazwa nabywcy',
    net: 'Netto',
    handleChangeToSent: `Czy na pewno chcesz zmienić status tej faktury na 'Wysłana'?`,
    handleChangeToDraft: `Czy na pewno chcesz zmienić status tej faktury na 'Szkic'?`,
    handleChangeToGenerated: `Czy na pewno chcesz zmienić status tej faktury na 'Zatwierdzona'?`,
    markAsSent: 'Oznacz jako wysłana',
    undoApproval: 'Cofnij zatwierdzenie',
    undoSend: 'Cofnij wysłanie',
    correctionReason: 'Przyczyna wystawienia korekty',
    correctionReasonDesc: 'Opis przyczyny wystawienia korekty',
    onePositionOnInvoice: 'Jedna pozycja na fakturze',
    textOverItems: 'Tekst do wydruku nad pozycjami',
    documentApproved: 'Dokument zostanie zatwierdzony z datą wystawienia',
    andSalesDate: 'oraz z datą sprzedaży',
    diffVatRates:
      'W pozycjach faktury występują różne stawki VAT dla pozycji. Aby kontynuować, odznacz pole',
    orSetSameVatRates: 'lub ustaw jednakowe stawki VAT dla pozycji.',
    wrongTryAgain: 'Coś poszło nie tak. Spróbuj ponownie.',
    drafts: 'Szkice',
    approved: 'Zatwierdzone',
    waitingForKSeF: 'Oczekujące na KSeF',
    rejectedFromKSeF: 'Odrzucone z KSeF',
    offlineKSeF: 'Offline KSeF',
    all: 'Wszystkie',
    exportFvs: 'Eksport faktur sprzedaży',
    xmlClosed: `Uwaga! Wysłanie faktur zatwierdzonych do Symfonii Handel jest dostępne
              w menu "Eksport FVS do Symfonii Handel". Paczki XML nie są już
              generowane i używane.`,
    invoicesDomesticToSent: 'FVS krajowe do wysłania',
    createInvoicesDomesticToSent: 'Utwórz XML z krajowymi FVS',
    invoicesForeignToSent: 'FVS zagraniczne do wysłania',
    createInvoicesForeignToSent: 'Utwórz XML z zagranicznymi FVS',
    packagesFVS: 'Paczki FVS',
    basicData: 'Dane podstawowe',
    invoicePositions: 'Pozycje faktury',
    summary: 'Podsumowanie',
    unwrittenUppercase: 'NIEZAPISANA',
    sentEmail: 'Wysłano e-mailem na adresy:',
    archiveUpperCase: 'ARCHIWUM',
    packageWithNumber: 'w paczce o nr sys.',
    toSHWithDate: 'do SH dnia',
    saleInvoice: 'Faktura sprzedaży',
    correction: 'Korekta',
    toSaleInvoice: 'do faktury sprzedaży',
    invoicesToCorrect: 'Faktury sprzedaży do skorygowania',
    alertDraftInvoiceCorrectionCreation:
      'Uwaga: zostanie automatycznie utworzony szkic korekty do faktury sprzedaży nr {{number}}. Czy na pewno chcesz kontynuować?',
    noPositionsToInvoice: 'Brak dostępnych pozycji do zafakturowania.',
    atLeastOneValueInPositionsFilled:
      'Przynajmniej jedna pozycja musi mieć Kwotę sprzedaży lub Kwotę prowizji większą od 0.',
    position: 'Pozycja',
    noSymphonyCode: 'Brak kodu Symfonii dla kontrahenta',
    noSymphonyCodeForRecipient:
      'Brak kodu Symfonii dla odbiorcy faktury i spółki',
    noSymphonyOrRecipientCode:
      'Brak kodu Symfonii dla kontrahenta lub odbiorcy',
    correctionToInvoice: 'Korekta do faktury',
    invoicesInPackage:
      'Faktury zawarte w paczce nr sys. {{number}} z dnia {{date}}',
    createXML10FVS: 'Utwórz XML z krajowymi FVS (10 - najstarszych)',
    oldest10: '10 - najstarszych',
    askCreatePackage: 'Czy na pewno utworzyć paczkę FVS?',
    noUnsentInvoices: 'Brak niewysłanych faktur sprzedaży w systemie.',
    export: 'Eksport',
    domestic: 'Krajowe',
    foreign: 'Zagraniczne',
    openInstructionNewWindow: 'Otwórz instrukcję fakturowania w nowym oknie',
    invoiceInstruction: 'Instrukcja fakturowania',
    invoiceInstructionShort: 'Instr. fakt.',
    rejected: 'Odrzucono',
    salesInvoicing: 'Sprzedaż - zafakturowanie',
    salesInvoicingFileName: 'SprzedazZafakturowanie',
    hideInvoiced: 'Ukryj zafakturowane',
    changeToReady: 'Data zmiany na obecny status',
    statusInDocs: 'Status ma potw. w dok.',
    hasCorrection: 'Wystawiono korektę FVS',
    salesTotal: 'Total sprzedaż',
    amountToInvoiced: 'Kwota do zafakturowania',
    commentMediaPlanner: 'Komentarz mediaplanera',
    commentFinance: 'Komentarz finanse',
    markerForFinance: 'Zmień status na "Cofnięty"',
    askChangeToWithdrawn: 'Czy na pewno ustawić stan "Cofnięty"?',
    sentToSymphonyHandelTs: 'Wysłano do Symfonii Handel',
    noSentInvoices: 'Brak wysłanych faktur sprzedaży w systemie.',
    sysNumber: 'Nr sys. faktury',
    invoiceStatus: 'Status faktury',
    sentByEmail: 'Wysłano e-mailem',
    insertNamesFromClipboard: 'Wklej nazwy pozycji',
    insertAmountsFromClipboard: 'Wklej kwoty netto pozycji',
    insertFromExcel: 'Wklej dane skopiowane z Excela',
    tooManyValues:
      'Wklejono za dużo wartości. Maksymalna liczba wierszy: {{maxRows}}, wklejono: {{count}}',
    invalidNumberFormat:
      'Oczekiwane są liczby. Nieprawidłowe wartości: {{values}}{{suffix}}',
    invalidNumberFormatMore: '(i {{count}} więcej)',
    pasteDataLabel: 'Wklej dane (każda wartość w osobnym wierszu):',
    fillAllFieldsWithSales: 'Wypełnij wszystkie widoczne pola kwotą sprzedaży',
    fillNotAssignedAmountWithSales: 'Wypełnij kwotą sprzedaży',
    fillAllFieldsWithCommission:
      'Wypełnij wszystkie widoczne pola kwotą prowizji',
    fillNotAssignedAmountWithCommission: 'Wypełnij kwotą prowizji',
    subjectToKSeF: 'Podlega wysyłce do KSeF',
    rejectedFromKSeFNotToSH:
      'Faktura odrzucona przez KSeF. Nie podlega ponownej wysyłce do Symfonii Handel.',
    rejectionReason: 'Przyczyna odrzucenia w KSeF',
    noRejectionReason: 'Brak informacji w POK o przyczynie odrzucenia',
    waitingForKSeFNumber: 'Oczekuje na nadanie numeru KSeF',
    offline: 'OFFLINE',
    ksefNumber: 'Numer KSeF',
    ksefAcceptanceDate: 'Data nadania nr w KSeF',
    openInvoicePrint: 'Otwórz wydruk faktury',
    previewInvoice: 'Wydruk poglądowy faktury',
    paymentStatus: 'Status płatności',
    paymentsFor: 'Wpłaty do faktury',
    fromDate: 'z dnia',
    invoiceGrossAmount: 'Kwota brutto faktury',
    totalPaidAmount: 'Suma wpłat',
    remainingBalance: 'Pozostało do zapłaty',
    remainingBalanceTooltip: 'Pozostało do zapłaty wg danych w księgowości',
    paymentDueDate: 'Termin płatności',
    paymentDueDateTooltip: 'Szacowany termin płatności',
    paymentAmount: 'Kwota wpłaty',
    paymentType: 'Typ płatności',
    currentBalance: 'Aktualne saldo',
    paymentsList: 'Lista wpłat',
    correctionDate: 'Data wystawienia korekty',
    lp: 'Lp.',
    orderNumbers: 'Zamówienia do faktury',
    orderNumber: 'Numer zamówienia',
    addOrderNumber: 'Dodaj numer zamówienia',
    editOrderNumber: 'Edytuj numer zamówienia',
    deleteOrderNumber: 'Usuń numer zamówienia',
    deleteOrderNumberConfirm: 'Czy na pewno usunąć numer zamówienia?',
    noOrderNumbers: 'Brak numerów zamówień',
    orderDate: 'Data zamówienia',
    purchaserDataChangedAlert:
      'Dane nabywcy uległy zmianie od czasu wystawienia faktury korygowanej.',
    recipientDataChangedAlert:
      'Dane odbiorcy uległy zmianie od czasu wystawienia faktury korygowanej.',
    formalCorrectionWillBeIssued:
      'Zostanie wystawiona korekta danych formalnych.',
    rejectedFromKSeFEditWarning:
      'Uwaga: zmiany wprowadzone w POK na odrzuconej przez KSeF fakturze sprzedaży nie są automatycznie przesyłane do Symfonii Handel.',
    rejectedFromKSeFEditSteps:
      'Kolejność działań: 1. Poprawa danych w POK i ustawienie faktury w stan "Wysłana" → 2. Poprawa danych w Symfonii Handel → 3. Ponowna wysyłka do KSeF z Symfonii Handel.',
  },
  symphony: {
    symphonyNew: 'Nowy kod',
    code: 'Kod',
    codes: 'Kody Symfonii',
    noSymphonyForClient: 'Brak kodów Symfonii dla tego kontrahenta.',
    symphonyEdit: 'Edycja kodu',
    symphonyAdd: 'Dodawanie nowego kodu',
    clientsWithSymphony: 'Kontrahenci - Symfonia',
    clientsNoSymphonyFVS: 'Kontrahenci bez kodu Symfonii (Faktury sprzedaży)',
    clientsNoSymphonyFVZ: 'Kontrahenci bez kodu Symfonii (Faktury zakupu)',
    sendUnsentFVSAll: 'Wyślij wszystkie FVS',
    sendUnsentFVS: 'Wyślij zaznaczone FVS ({{number}} szt.)',
    sendingFVSToSymfoniaFinished:
      'Wysyłka faktur sprzedaży do tabel przejściowych Symfonia Handel została zakończona.',
    exportFVSToSymfonia: 'Eksport faktur sprzedaży do Symfonii Handel',
    FVSToSend: 'FVS do wysłania',
    askSendToSymphony:
      'Czy na pewno wysłać faktury do bazy przejściowej Symfonii Handel?',
    sentFVS: 'FVS wysłane',
    noUnsentFVS: 'Brak niewysłanych faktur sprzedaży do Symfonii Handel.',
    noSentFVS: 'Brak wysłanych faktur sprzedaży do Symfonii Handel.',
    symphonyNumberNotFound:
      'Nie znaleziono numeru Symfonii dla rozliczonego klienta i spółki',
    invoiceWontBeImported:
      'Faktura po zatwierdzeniu nie zostanie wyeksportowana do systemu Symfonia.',
    clients: 'Kontrahenci',
    noClients: 'Brak kontrahentów w systemie',
    importErrors: 'Błędy importu FVS do Symfonii Handel',
    noImportErrors: 'Brak błędów importu FVS do Symfonii Handel',
    askResendToSymphony:
      'Czy na pewno ponownie wysłać fakturę sprzedaży do bazy przejściowej Symfonii Handel?',
    resendToSymphony: 'Wyślij ponownie do Symfonii Handel',
    warningResend:
      'UWAGA! Faktura była już wysłana do Symfonii Handel po dacie powstania tego błędu importu.',
  },
  sendEmail: {
    toClients: 'Wysyłka e-maili do kontrahentów',
    waitingToSendWithEmail: 'Oczekujące na wysłanie',
    waitingToSendWithoutEmail: 'Nie posiadają zdefiniowanych adresów e-mail',
    waitingToSendWithMoreEmail: 'Posiadają więcej niż jeden adres e-mail',
    sendAllUnsent: 'Wyślij wszystkie FVS',
    sendAllUnsentInOneEmail: 'Wyślij wszystkie FVS w jednym e-mailu',
    sendUnsent: 'Wyślij zaznaczone FVS ({{number}} szt.)',
    sendUnsentInOneEmail:
      'Wyślij zaznaczone FVS w jednym e-mailu ({{number}} szt.)',
    askSendEmails: 'Czy na pewno wysłać e-maile do kontrahentów?',
    askSendEmailsManyInOneMail:
      'Czy na pewno wysłać faktury do kontrahentów w jednej wiadomości e-mail?',
    askSendEmail: 'Czy na pewno ponownie wysłać e-mail do kontrahenta?',
    emailSubject: 'Niestandardowy temat e-maila',
    emailText: 'Niestandardowa treść e-maila',
    attachments: 'Niestandardowe załączniki e-maila',
    emailTextSubject: 'Niestandardowa treść, temat lub załączniki e-maila',
    editEmailTextSubject:
      'Edycja niestandardowej treści, tematu lub załączników e-maila',
    addEmailTextSubject:
      'Dodawanie niestandardowej treści, tematu lub załączników e-maila',
    newEmailNote: 'Nowa, niestandardowa treść, temat lub załączniki e-maila',
    editEmailNote:
      'Edycja niestandardowej treści, tematu lub załączników  e-maila',
    askDeleteEmailText:
      'Czy na pewno usunąć niestandardową treść, temat i załączniki e-maila?',
    to: 'Do',
    cc: 'DW',
    emailTextSubjectRequired:
      'Proszę podać tytuł, treść lub dodać załączniki e-maila.',
    chooseEmailAddress: 'Wybierz adresy e-mail',
    changeEmailAddress: 'Zmień adresy e-mail',
    sentEmails: 'Wysłane e-maile',
    sendingInProgress: 'Trwa wysyłanie wiadomości e-mail...',
    sendAgain: 'Wyślij ponownie e-mail',
    warningSelectEmailAddress:
      'Uwaga: należy wybrać adresy e-mail, na które zostanie wysłany e-mail do kontrahenta.',
    emailFrom: 'Nadawca e-maila',
    emailWillBeSend: 'Wysłany zostanie na adresy:',
    toAddress: 'Adres do',
    ccAddress: 'Adres DW',
    fromAddress: 'Wysłany z adresu',
    noEmailAddresses: 'Brak ustawionych adresów e-mail do wysyłki FVS.',
    subject: 'Temat e-maila',
    message: 'Treść e-maila',
    sendAgainFVS: 'Wyślij ponownie ORYGINAŁ FVS',
    sendAgainFVSDuplicate: 'Wyślij DUPLIKAT FVS',
    invoiceDuplicate: 'Duplikat faktury',
    sendInOneEmail: 'Wysyłka wybranych FVS w jednym e-mailu',
    fileUpload: 'Załącz pliki',
    customEmail: 'Niestandardowy e-mail',
    clientsEmails: 'Adresy e-maili kontrahentów',
  },
} as const;
